<template>
	<div v-show="bodyIsShow">
		<input type="hidden" id="cityPy" :value="cityPy">
		<input type="hidden" id="serachUlr" value="/Search/serachEmpty">
		<div class="bodywrap">
			<header id="header-search" class="header-search">
				<div class="head">
					<a id="searchBack" style="display:none;" href="javascript:void(0);" class="lefticon"></a>
					<a href="/city.html" class="cityicon"><span v-text="cityName"></span><em class="header-arror"></em></a>
					<span class="header-search-form">
						<!-- <form action="/search/search" method="post"> -->
						<form onsubmit="return false">
							<input class="header-search-sub" type="submit" value="" />
							<!-- <input id="search-txt" name="keyword" class="header-search-txt" type="text" placeholder="请输入车型/品牌"/> -->
							<p @click="toSearchPage" class="header-search-txt search-click">请输入车型/品牌</p>
							<em id="search-close" class="search-close">×</em>
						</form>
					</span>
					<a href="/usercenter/center" class="personicon"></a>
				</div>
			</header>
			<div id="nosearch">
				<mt-swipe :auto="4000">
				  <mt-swipe-item v-for="(item,index) in bannerList">
				  	<a :href="item.link">
				  		<img class="swiper-img" :src="commmonWebConfig.picHost+'/'+item.imgUrl">
				  	</a>
				  </mt-swipe-item>
				</mt-swipe>
				<section v-if="iconList.length > 0" id="search-Mark">
					<ul :class="['clearfix', 'indexIcon' , (iconList.length <= 3 || iconList.length == 5 || iconList.length == 6) ? 'indexIcon-nor' : '' ]">
				             <li v-for="(item,index) in iconList">
		        				<a v-if="item.id==1" @click="toBuyNewCarPage"><em :class="['trackEvent','indexIcon-em','indexIcon-em'+(index+1)] " :data-track = "'index-'+cityId+'-'+item.id+'-ball'" :data-val="'index-'+cityId+'-'+item.id+'-ball'" :style="'background: url('+commmonWebConfig.picHost+'/'+item.imgUrl+') no-repeat; background-size: 100% 100%;'"></em><span v-text="item.title"></span></a>
		        				<a v-else :href="item.link"><em :class="['trackEvent','indexIcon-em','indexIcon-em'+(index+1)] " :data-track = "'index-'+cityId+'-'+item.id+'-ball'" :data-val="'index-'+cityId+'-'+item.id+'-ball'" :style="'background: url('+commmonWebConfig.picHost+'/'+item.imgUrl+') no-repeat; background-size: 100% 100%;'"></em><span v-text="item.title"></span></a>
		        			</li>
			        </ul>
				</section>
				<section v-if="extendList.length > 0">
					<!--一条-->
			        <table v-if="extendList.length == 1" class="tuiguang01">
			            <tr>
			                <td>
			                    <a :href="extendList[0].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[0].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[0].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[0].imgUrl">
			                        </div>
			                    </a>
			                </td>
			            </tr>
			        </table>
			        <!--二条-->
			        <table v-if="extendList.length == 2" class="tuiguang02">
			            <tr>
			                <td>
			                    <a :href="extendList[0].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[0].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[0].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[0].imgUrl">
			                        </div>
			                    </a>
			                </td>
			                <td class="index-table-border">
			                    <a :href="extendList[1].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[1].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[1].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[1].imgUrl">
			                        </div>
			                    </a>
			                </td>
			            </tr>
			        </table>
			        <!--三条-->
			        <table v-if="extendList.length == 3" class="tuiguang03">
			            <tr>
			                <td valign="top" rowspan ="2" class="listLeft index-table-border-bottom">
			                    <a :href="extendList[0].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[0].title"></p>
			                            <p class="tuiguang01-txt-gray tuiguang03-txt-gray" v-text="extendList[0].subTitle"></p>
			                        </div>
			                        <div class="tuiguang01-img">
			                        	<img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[0].imgUrl">
			                        </div>
			                    </a>
			                </td>
			                <td class="index-table-border index-table-border-bottom">
			                    <a :href="extendList[1].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[1].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[1].subTitle"></p>
			                        </div>
			                        <div class="tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[1].imgUrl">
			                        </div>
			                    </a>
			                </td>
			            </tr>
			            <tr>
			                <td class="index-table-border">
			                    <a :href="extendList[2].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[2].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[2].subTitle"></p>
			                        </div>
			                        <div class="tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[2].imgUrl">
			                        </div>
			                    </a>
			                </td>
			            </tr>
			        </table>
			        <!--四条-->
			        <table v-if="extendList.length == 4" class="tuiguang02">
			            <tr>
			                <td class="index-table-border-bottom">
			                    <a :href="extendList[0].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[0].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[0].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[0].imgUrl">
			                        </div>
			                    </a>
			                </td>
			                <td class="index-table-border index-table-border-bottom">
			                    <a href="${extendList[1].link }">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[1].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[1].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[1].imgUrl">
			                        </div>
			                    </a>
			                </td>
			            </tr>
			            <tr>
			                <td>
			                    <a :href="extendList[2].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[2].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[2].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[2].imgUrl">
			                        </div>
			                    </a>
			                </td>
			                <td class="index-table-border">
			                    <a :href="extendList[3].link">
			                        <div class="clearfix tuiguang01-txt">
			                            <p class="tuiguang01-txt-tit" v-text="extendList[3].title"></p>
			                            <p class="tuiguang01-txt-gray" v-text="extendList[3].subTitle"></p>
			                        </div>
			                        <div class="fr tuiguang01-img">
			                            <img class="scrollLoading" v-lazy="commmonWebConfig.picHost+'/'+extendList[3].imgUrl">
			                        </div>
			                    </a>
			                </td>
			            </tr>
			        </table>
				</section>
				<div class="clearfix">
					<img class="addpic" :src="commmonWebConfig.static+'/img/default/addimg.png'" />
				</div>
				<!-- TOTO: 团车商城-->
				<!-- 团车商城start -->
				<section v-if="mallList.length > 0" class="marB1 backgroundFFF">
					<div class="titleIn"><span class="titleIn-em-red"><em></em>团车商城</span>
					</div>
					<a v-for="(item,index) in mallList" :href="'/mall/youh/act/'+item.id">
						<div class="carshopping clearfix">
							<div class="car-item clearfix">
								<div class="car-img fl">
									<img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/blank.gif'" :data-url="item.brandImg">
								</div>
								<div class="car-size fr">
									<div class="tit" v-text="'【'+item.brandName+'】'+item.mainTitle"></div>
									<span class="car-number">已抢<span v-text="item.baseNum"></span>件</span>
									<div class="car-price" v-if="item.carstyleYhList !=null">
										￥<span class="num" v-text="item.carstyleYhList[0].paymentPriceStr"></span> <span class="deduction">
										抵<span v-text="item.carstyleYhList[0].deductionPriceStr.replace(/,/,'')"></span>元</span>
									</div>
									<span class="purchase">立即购买</span>
								</div>
							</div>
						</div>
					</a>
				</section>
				<!-- 团车商城end -->
				<!--新能源 start-->
			    <!-- <section class="marB1 backgroundFFF">
				    <div class="titleIn">
				    	<span class="titleIn-em-red"><em></em>热销车型</span>
				    	<a class="fr titleInLink" :href="'/mall/ev/'+cityPy+'/'">更多<em class="icon-arror-r"></em></a>
				    </div>
			        <div class="carList">
			        		<ul>
					                <li v-for="(item,index) in selfCars" class="clearfix" v-if="index < 4">
					                    <a :href="item.link">
					                        <div class="fl carList-img">
			                           			<em v-if="item.carType == 2" class="icon-new"></em>
					                            <img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/blank.gif'" :data-url="commmonWebConfig.picHost+'/'+item.imgUrl">
					                        </div>
					                        <div class="fr carList-info">
					                        	<div v-if="item.carType == 2">
					                        		<div class="carList-info-tit" v-text="item.styleName"></div>
						                            <p class="carList-info-gray">续航里程：<span v-text="item.mileage"></span></p>
						                            <p class="carList-info-gray">补贴：<span class="font-green" v-text="item.subsidy"></span></p>
						                            <p class="carList-info-price">厂商指导价：<span class="font-red" v-text="item.factoryPrice "></span></p>
					                        	</div>
					                        	<div v-if="item.carType == 1">
					                        		<div class="carList-info-tit" v-text="item.styleName"></div>
						                            <p class="carList-info-gray">排量：<span v-text="item.level"></span></p>
						                            <p class="carList-info-gray">变速箱：<span v-text="item.speedBox"></span></p>
						                            <p class="carList-info-price">厂商指导价：<span class="font-red" v-text="item.factoryPrice"></span></p>
					                        	</div>
					                        </div>
					                    </a>
					                </li>
			               </ul>
			        </div>
			    </section> -->
				<!--新能源 end-->
				<section v-if="hotBrandList.counts > 0" class="marB1 backgroundFFF">
					<!--TODO-->
					<div v-if="hotBrandList.counts >= 10" class="titleIn">
						<span class="titleIn-em-zi"><em></em>热销品牌</span>
						<!-- <a class="fr titleInLink" :href="'/'+cityPy+'/plan?cityId='+cityId"><span class="font-lightred" v-text="hotBrandList.counts"></span>个品牌<em class="icon-arror-r"></em> -->
						<a class="fr titleInLink" @click="toBrandLists"><span class="font-lightred" v-text="hotBrandList.counts"></span>个品牌<em class="icon-arror-r"></em>
						</a>
					</div>
					 <div v-else class="titleIn">
					 	<span class="titleIn-em-zi"><em></em>热销品牌</span>
					 	<!-- <a class="fr titleInLink" :href="'/'+cityPy+'/plan?cityId='+cityId">更多<em class="icon-arror-r"></em></a> -->
					 	<a class="fr titleInLink" @click="toBrandLists">更多<em class="icon-arror-r"></em></a>
					 </div>

					<table class="brand-table">
						<tbody v-if="hotBrandList.list.length < 4">
							<tr>
								<td v-for="(item,index) in hotBrandList.list">
									<!-- <a :href="'/'+cityPy+'/b'+item.brandId+'/tuan'"> -->
									<a @click="toBrandLists">
										<p><img class="scrollLoading" v-lazy="item.logo"></p>
										<p class="hot-brand-tit">{{item.brandName}}</p>
									</a>
								</td>
								<td>
					                <!-- <a :href="'/'+cityPy+'/plan?cityId='+cityId"> -->
					                <a @click="toBrandLists">
					                  <p><img :src="commmonWebConfig.static+'/img/common/icon-point.png'"></p>
					                  <p class="hot-brand-tit">全部品牌</p>
					                </a>
				                </td>
							</tr>
						</tbody>
						<tbody v-if="hotBrandList.list.length == 4">
							<tr>
								<td v-for="(item,index) in hotBrandList.list">
									<!-- <a :href="'/'+cityPy+'/b'+item.brandId+'/tuan'"> -->
									<a @click="toBrandLists">
										<p><img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/icon-point.png'" :data-url="item.logo"></p>
										<p class="hot-brand-tit">{{item.brandName}}</p>
									</a>
								</td>
							</tr>
						</tbody>
						<tbody v-if="hotBrandList.list.length > 4 && hotBrandList.list.length < 8">
							<tr>
								<td v-if="index < 4" v-for="(item,index) in hotBrandList.list">
									<!-- <a :href="'/'+cityPy+'/b'+item.brandId+'/tuan'"> -->
									<a @click="toBrandLists">
										<p><img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/icon-point.png'" :data-url="item.logo"></p>
										<p class="hot-brand-tit">{{item.brandName}}</p>
									</a>
								</td>
							</tr>
							<tr>
								<td v-if="index >= 4" v-for="(item,index) in hotBrandList.list">
									<!-- <a :href="'/'+cityPy+'/b'+item.brandId+'/tuan'"> -->
									<a @click="toBrandLists">
										<p><img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/icon-point.png'" :data-url="item.logo"></p>
										<p class="hot-brand-tit">{{item.brandName}}</p>
									</a>
								</td>
								<td>
					                <!-- <a :href="'/'+cityPy+'/plan?cityId='+cityId"> -->
					                <a @click="toBrandLists">
					                  <p><img :src="commmonWebConfig.static+'/img/common/icon-point.png'"></p>
					                  <p class="hot-brand-tit">全部品牌</p>
					                </a>
				                </td>
							</tr>
						</tbody>
						<tbody v-if="hotBrandList.list.length >= 8">
							<tr>
								<td v-if="index < 4" v-for="(item,index) in hotBrandList.list">
									<!-- <a :href="'/'+cityPy+'/b'+item.brandId+'/tuan'"> -->
									<a @click="toBrandLists">
										<p><img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/icon-point.png'" :data-url="item.logo"></p>
										<p class="hot-brand-tit">{{item.brandName}}</p>
									</a>
								</td>
							</tr>
							<tr>
								<td v-if="index >= 4 && index < 8" v-for="(item,index) in hotBrandList.list">
									<!-- <a :href="'/'+cityPy+'/b'+item.brandId+'/tuan'"> -->
									<a @click="toBrandLists">
										<p><img class="scrollLoading" :src="commmonWebConfig.static+'/img/common/icon-point.png'" :data-url="item.logo"></p>
										<p class="hot-brand-tit">{{item.brandName}}</p>
									</a>
								</td>
							</tr>
						</tbody>

					</table>
				</section>
				<section class="marB1 backgroundFFF">
			        <div v-show="hotCarstyleList.counts > 10" class="titleIn">
			        	<span class="titleIn-em-or"><em></em>热门车型</span>
			        	<!-- <a class="fr titleInLink" :href="'/'+cityPy+'/plan?cityId='+cityId"> -->
			        	<a class="fr titleInLink" @click="toFilterCarStyle()">
			        		<span class="font-lightred" v-text="hotCarstyleList.counts"></span>个车型<em class="icon-arror-r"></em></a>
			        </div>
			        <div v-show="hotCarstyleList.counts <= 10" class="titleIn">
			        	<span class="titleIn-em-or"><em></em>热门车型</span>
			        	<!-- <a class="fr titleInLink" :href="'/'+cityPy+'/plan?cityId='+cityId">更多<em class="icon-arror-r"></em></!--> -->
			        	<a class="fr titleInLink" @click="toFilterCarStyle()">更多<em class="icon-arror-r"></em></a>
			        </div>
			        <ul class="clearfix hotCar">
			           <li v-for="(item,index) in hotCarstyleList.list">
			                <!-- <a :href="'/'+cityPy+'/c'+item.id+'/tuan'"> -->
			                <a @click="toCarStyleDetail(item.id)">
			                    <div class="hotCarLiIn">
			                        <div class="hotCar-img">
			                            <img class="scrollLoading" v-lazy="item.logo">
			                        </div>
			                        <p class="hotCar-tit" v-text="item.styleName"></p>
			                        <p class="hotCar-num">
										<span class="font-red" v-text="item.price+item.priceSuffix"></span> <!-- 这里放价格-->
			                        </p>
			                    </div>
			                </a>
			            </li>
			        </ul>
				</section>
				<section class="backgroundFFF">
					<div class="titleIn"><span class="titleIn-em-red"><em></em>报名购车</span></div>
					<form id="signUpfrom" action="" method="">
						<div class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon01"></em>
							<input id="userName" name="userName" placeholder="请输入姓名" class="signUpfrom-txt userName" type="text" maxlength="10" />
						</div>
						<div class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon02"></em>
							<input id="telphone" name="telphone" placeholder="请输入手机号码" class="signUpfrom-txt telphone" type="tel" maxlength="11" />
						</div>
						<div class="signUpform-com">
							<em class="signUpfrom-icon signUpfrom-icon03"></em>
							<div id="insertCar" class="signUpfrom-txt userName" >请选择品牌和车型</div>
							<em class="icon-arror-r"></em>
						</div>
						<div class="">
							<input @click="signUp()" class="signUpButton" type="button" value="立即报名">
						</div>
						<div style="margin:0;padding-bottom:1em;color:#999" class="addxyroom">*请放心填写,报名即视为同意<a href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a> </div>
					</form>
				</section>
				<!-- 底部 -->
				<footerComponent></footerComponent>
				<!--协议-->
				<!-- <agreementComponent></agreementComponent> -->
				<!--协议-->
			</div>
		</div>
		<div id="sider-mark" class="sider-mark"></div>
		<div id="sider-wrap" class="sider-wrap">
			<div id="side-brand" class="side-div side-brand">
			</div>
			<div id="side-carstyle" class="side-div side-carstyle">
			</div>
		</div>
		<!--搜索交互 start-->
		<div id="searching" class="searching">
			<div id="search-hot" class="search-hot">
				<ul class="clearfix search-hot-ul-flex">
			        <li v-for="(item,index) in searchStyleList">
			            <a :href="'/'+cityPy+'/c'+item.id+'/tuan'" v-text="item.styleName"></a>
			        </li>
					<li><a class="red" :href="'/'+cityPy+'/plan?cityId='+cityId">全部车型</a></li>
				</ul>
			</div>

			<div id="search-resultLink" class="search-resultLink">
				<ul class="search-resultLink-ul">
				</ul>
			</div>
		</div>
	</div>
</template>

<style scoped lang="less">
	@import "../../assets/less/common.less";
	.mint-swipe{
		height:5.333333rem;
		.swiper-img{
			width:10rem;
			height:5.333333rem;
		}
	}
	.header-search .header-search-form .header-search-txt.search-click{
		display: inline-block;
    color: rgb(255, 255, 255);
    vertical-align: middle;
    line-height: 0.7rem;
	}
</style>
<script>

import { Toast } from 'mint-ui';
import merge from 'webpack-merge';
export default {
	name: 'index',
	data:function() {
		return {
			bodyIsShow:false,
			cityPy:"bj",
			cityId:10,
			cityName : "北京",
			//广告图轮播
			bannerList:[],
			//icon
			iconList:[],
			//优惠模块
			extendList:[],
			//团车商场
			mallList:[],
			//新能源
			selfCars:[],
			//热门品牌
			hotBrandList:{
				counts:0,
				list:[],
			},
			//热门车型
			hotCarstyleList:{
				counts:0,
				list:[]
			},
			//搜索推荐的默认车型
			searchStyleList:[]
		}
	},
	beforeCreate:function(){
		getCommonJsIns.initCSS({
			cssURL:"/css/default/index.css"
		});
	},
	mounted:function(){
		var self = this;
		document.title="团车 - 中国领先的汽车交易服务平台";
		getCommonJsIns.initDefaultJS(self.webReady);

		/***统计添加**/
		!function(e, t, n, g, i) {
		    e[i] = e[i] || function() {
		    	(e[i].q = e[i].q || []).push(arguments)
		    };
		    var n = t.createElement("script");
		    var tag = t.getElementsByTagName("script")[0];
		    n.async = 1;
		    n.src = ('https:' == document.location.protocol ? 'https://': 'http://') + g;
		    tag.parentNode.insertBefore(n, tag);
		} (window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
		gio('init', '8004d11f5708cccc', {});
		//custom page code begin here
		//custom page code end here
		gio('send');
		gio('enableHT', 'true');
		/***统计添加**/


	},
	methods:{
		webReady:function(){
			var self = this;
			this.getInfo();
			//获取banner 获取icon等
			//this.getDataCenter();
			//获得团车商城
			//this.getMall();
			// //获取热门品牌的数量
			//this.getHotBrandCount();
			// //获取热门品牌的列表
			//this.getHotBrandList();
			// //获取热门车型的数量
			//this.getHotCarstyleCount();
			// //获取热门车型的列表
			//this.getHotCarstyleList();
			//getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/default/index.js",function(){});
		},
		getInfo:function(){
			var self = this;
			// var _data=self.$route.params.cityPy?{cityPy:self.$route.params.cityPy}:{};
			var _data=self.$route.query.cityPy?{cityPy:self.$route.query.cityPy}:{};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.cities,
				type:"get",
				// data:{
				// 	cityPy:self.$route.params.cityPy?self.$route.params.cityPy:"bj"
				// },
                data:_data,
				success:function(data){
					if(data.responseHeader.status == 200){
						self.cityPy = data.response.result.py;
						self.cityId = data.response.result.id;
						self.cityName = data.response.result.name;
						// 接口返回后重新复制，避免用户输入错误给后台造成困扰
						self.$router.push({
							query:merge(self.$route.query,{cityPy:self.cityPy})
						})
						self.checkPosition();
						self.getDataCenter();
						self.getMall();
						self.getHotBrandCount();
						self.getHotBrandList();
						self.getHotCarstyleCount();
						// //获取热门车型的列表
						self.getHotCarstyleList();
						window.cityId = self.cityId;
						// getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/default/index.js",function(){});
						setTimeout(function(){
							getCommonJsIns.loadJs(self.commmonWebConfig.static + "/js/app/default/index.js",function(){});
						},500);
					}
				}
			})
		},
		checkPosition:function(){
			var self = this;
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.checkPosition,
				type:"get",
				data:{
					// cityPy:self.$route.params.cityPy?self.$route.params.cityPy:"bj"
                    cityPy:self.cityPy
				},
				success:function(data){
					if(data.responseHeader.status == 200){
						if(data.response.result.needJump == 1){
							window.location.href = "/hmtcj/"+self.cityPy;
						}else{
							self.bodyIsShow = true;
						}
					}else{
						self.bodyIsShow = true;
					}
				},
				error:function(){
					self.bodyIsShow = true;
				}
			})
		},
		getDataCenter:function(){
			var self = this;
			var data={
				cityId:this.cityId,
				cityPy:this.cityPy,
				source:1
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.configs,
				type:"get",
				data:data,
				success:function(data){
					console.log(data);
					if(data.responseHeader.status == 200){
						self.bannerList = data.response.result.banners;
						self.iconList = data.response.result.cityicons;
						self.extendList = data.response.result.extendList;
						for(var i in self.iconList){
							self.iconList[i].link = self.iconList[i].link.replace("{city}",self.cityPy);
							self.iconList[i].link = self.iconList[i].link.replace("{cityId}",self.cityId);
						}
						console.log(self.iconList);
						//TODO
						//self.selfCars = data.response.result.selfCars;
					}

				}
			})
		},
		addxydetail: function() {
			agreementUtil.agreement.init();
			// $(".xymarsk").show();
			// $(".addxypop-mark").show();
			// $('html').css({
			// 	"overflow-y": "hidden"
			// });
			// $('body', 'html').css({
			// 	"position": "fixed",
			// 	"left": "50%",
			// 	"margin-left": "-5rem",
			// 	"top": 0
			// });

		},
		getMall:function(){
			var self = this;
			var data={
				cityId : this.cityId,
				fields : 'eventInfo'
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.eventInfo,
				type:"get",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){
						self.mallList = data.response.result;
					}
				}
			})
		},
		getHotBrandCount:function(){
			var self = this;
			var data = {
				cityId : this.cityId,
				fields : 'count'
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.carBrands,
				type:"get",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){

						self.hotBrandList.counts = data.response.result;
					}

				}
			})
		},
		getHotBrandList:function(){
			var self = this;
			var data={
				cityId : this.cityId,
				pageSize : 8
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.hotBrand,
				type:"get",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){
						self.hotBrandList.list = data.response.result;
					}

				}
			})
		},
		getHotCarstyleCount:function(){
			var self = this;
			var data={
				cityId : this.cityId,
				fields : 'count'
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.carStyles,
				type:"get",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){
						self.hotCarstyleList.counts = data.response.result;
					}

				}
			})
		},
		getHotCarstyleList:function(){
			var self = this;
			var data = {
				cityId : this.cityId,
				pageSize : 4
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.hotStyles,
				type:"get",
				data:data,
				success:function(data){
					if(data.responseHeader.status == 200){
						self.hotCarstyleList.list = data.response.result;
					}

				}
			});
			var data1 = {
				cityId:this.cityId,
				pageSize : 11
			};
			self.ajaxSubmit.ajax({
				url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.hotStyles,
				type:"get",
				data:data1,
				success:function(data){
					if(data.responseHeader.status == 200){
						self.searchStyleList = data.response.result;
//						console.log(data.response.result)
					}
				}
			});
		},
		signUp:function(){
			var self = this;
			var relF = $("#side-carstyle").data("dada");
			if(($("#insertCar").text()) == "请选择意向品牌和意向车型") {
			 	Toast({
                  message: "请选择意向品牌和意向车型",
                  position: 'middle',
                  duration: 2000
                });
				return false;
			}else if(!webCommonUtil.commonFun.isName($("#userName").val())){
				Toast({
                  message: "请填写真实姓名",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else if(!webCommonUtil.commonFun.isPhone($("#telphone").val())){
				Toast({
                  message: "请填写11位手机号码",
                  position: 'middle',
                  duration: 2000
                });
                return false;
			}else{
				if(relF) {
					$("#signUpButton").attr("disabled", "disabled");
					var rel = relF.split("@#");
					var data = {
						"sourceUrl": window.location.href,
						"cityId": cityId,
						"name": $("#userName").val(),
						"phone": $("#telphone").val(),
						"buyType": $("#buyType").val(),
						"splitMoney": $("#splitMoney").val(),
						"brandId": rel[0],
						"carStyleId": rel[1]
					}
					self.ajaxSubmit.ajax({
						url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
						type:"post",
						data:data,
						success:function(data){
							if(data.responseHeader.status == 200){
								Toast({
				                  message: "报名成功",
				                  position: 'middle',
				                  duration: 2000
				                });
							}
						},
						error:function(){
							$("#signUpButton").removeAttr("disabled");
						}
					});
				}
			}
		},
		// 跳转到买新车搜索页
		toSearchPage(){
			// this.$router.push({path: "/buynewcar/search"});
			window.location.href = window.location.origin + "/buynewcar/search";
		},
		// 跳转到买新车首页
		toBuyNewCarPage(){
			// this.$router.push({path: "/buynewcar"})
			window.location.href = window.location.origin + "/buynewcar";
		},
		// 跳转到全部品牌页
		toBrandLists(){
			// this.$router.push({path: "/buynewcar/xuanche"})
			window.location.href = window.location.origin + "/buynewcar/xuanche";
		},
		// 跳转到买新车综述页
		toCarStyleDetail(csId){
			// this.$router.push({path: "/buynewcar/carstyledetail",query:{csId:csId}})
			window.location.href = window.location.origin + "/buynewcar/carstyledetail?csId=" + csId;
		},
		// 跳转到筛选车型页
		toFilterCarStyle(brandId){
			// this.$router.push({path: "/buynewcar/result",query:{brand: brandId}})
			if(brandId){
				window.location.href = window.location.origin + "/buynewcar/result?brand=" + brandId;
			}else{
				window.location.href = window.location.origin + "/buynewcar/result";
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/views/default/index.vue